(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hadaki-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hd-faq')) {
    customElements.define('hd-faq', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.querySelectorAll('details').forEach(detail => {
          detail.addEventListener('toggle', () => {
            if (!detail.open || motion.matches) return;
            const answer = detail.querySelector('.hd-faq__answer');
            if (typeof answer.animate === 'function') answer.animate([{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 280, easing: 'ease-out' });
          }, { signal: this.controller.signal });
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hadaki-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hd-home-motion')) {
    customElements.define('hd-home-motion', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.track = this.querySelector('[data-hd-track]');
        this.stage = this.querySelector('[data-hd-stage]');
        this.scene = this.querySelector('[data-hd-scene]');
        this.products = [...this.querySelectorAll('[data-hd-product]')];
        this.satellites = [...this.querySelectorAll('[data-hd-satellite]')];
        this.details = [...this.querySelectorAll('[data-hd-detail]')];
        this.buttons = [...this.querySelectorAll('[data-hd-stage-button]')];
        this.rings = [...this.querySelectorAll('[data-hd-ring]')];
        this.progressBar = this.querySelector('[data-hd-progress]');
        this.counter = this.querySelector('[data-hd-counter]');
        this.shadow = this.querySelector('[data-hd-shadow]');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.current = 0;
        this.target = 0;
        this.active = -1;
        const options = { signal: this.abort.signal };
        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => this.goTo(index), options);
          button.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % 3;
            else if (event.key === 'ArrowLeft') next = (index + 2) % 3;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = 2;
            else return;
            event.preventDefault();
            this.buttons[next].focus({ preventScroll: true });
            this.goTo(next);
          }, options);
        });
        this.onScroll = () => {
          if (this.reduced.matches || !this.startReady) return;
          this.target = this.readProgress();
          this.requestFrame();
        };
        document.addEventListener('scroll', this.onScroll, { ...options, capture: true, passive: true });
        window.addEventListener('scroll', this.onScroll, { ...options, passive: true });
        window.addEventListener('resize', () => this.measure(), { ...options, passive: true });
        this.reduced.addEventListener('change', () => this.configure(), options);
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.stage);
        const header = document.getElementById('header-group');
        if (header) this.resizeObserver.observe(header);
        this.configure();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      configure() {
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.classList.toggle('is-motion', !this.reduced.matches);
        if (this.reduced.matches) return;
        this.measure();
        this.current = this.target;
        this.draw();
      }
      findScroller() {
        let element = this.parentElement;
        while (element && element !== document.body) {
          const style = getComputedStyle(element);
          if (/(auto|scroll)/.test(style.overflowY) && element.scrollHeight > element.clientHeight + 1) return element;
          element = element.parentElement;
        }
        return window;
      }
      scrollTop() {
        return this.scroller === window ? window.scrollY : this.scroller.scrollTop;
      }
      measure() {
        if (this.reduced.matches || !this.isConnected) return;
        this.scroller = this.findScroller();
        const header = document.getElementById('header-group');
        const headerHeight = header?.getBoundingClientRect().height || (window.innerWidth < 821 ? 60 : 64);
        this.style.setProperty('--hd-motion-top', `${Math.round(headerHeight)}px`);
        const scrollerTop = this.scroller === window ? 0 : this.scroller.getBoundingClientRect().top;
        this.start = this.track.getBoundingClientRect().top - scrollerTop + this.scrollTop() - headerHeight;
        this.distance = Math.max(1, this.track.offsetHeight - this.stage.offsetHeight);
        const sceneBounds = this.scene.getBoundingClientRect();
        this.sceneWidth = sceneBounds.width;
        this.sceneHeight = sceneBounds.height;
        this.compact = sceneBounds.width < 750;
        this.satelliteSizes = this.satellites.map(element => ({ width: element.offsetWidth, height: element.offsetHeight }));
        this.startReady = true;
        this.target = this.readProgress();
        this.requestFrame();
      }
      readProgress() {
        return Math.max(0, Math.min(1, (this.scrollTop() - this.start) / this.distance));
      }
      requestFrame() {
        if (!this.frame) this.frame = requestAnimationFrame(() => this.tick());
      }
      tick() {
        this.frame = 0;
        if (!this.isConnected || this.reduced.matches) return;
        this.current += (this.target - this.current) * 0.18;
        if (Math.abs(this.target - this.current) < 0.00015) this.current = this.target;
        this.draw();
        if (this.current !== this.target) this.requestFrame();
      }
      smooth(start, end, value) {
        const x = Math.max(0, Math.min(1, (value - start) / (end - start)));
        return x * x * (3 - 2 * x);
      }
      draw() {
        const timeline = Math.max(0, Math.min(2, this.current * 2.4 - 0.2));
        const width = Math.min(this.sceneWidth, 850);
        const height = this.sceneHeight;
        this.products.forEach((product, index) => {
          const delta = timeline - index;
          const distance = Math.abs(delta);
          const x = -delta * width * (this.compact ? 0.91 : 0.7);
          const y = delta > 0 ? -delta * height * 0.46 : -delta * height * 0.22;
          const rotation = -delta * 34;
          const tilt = delta * 14;
          const scale = Math.max(0.58, 1 - distance * 0.24);
          const opacity = 1 - this.smooth(0.2, 0.88, distance);
          product.style.transform = `translate(-50%,-50%) translate3d(${x.toFixed(2)}px,${y.toFixed(2)}px,0) rotateZ(${rotation.toFixed(2)}deg) rotateY(${tilt.toFixed(2)}deg) scale(${scale.toFixed(4)})`;
          product.style.opacity = opacity.toFixed(4);
        });
        const transition = Math.sin(Math.PI * (timeline % 1));
        const orbitWidth = Math.min(width, this.compact ? 390 : 620);
        const points = this.compact ? [[-0.26,-0.30],[0.26,-0.26],[-0.29,0.27],[0.29,0.31]] : [[-0.40,-0.30],[0.40,-0.22],[-0.42,0.25],[0.42,0.31]];
        this.satellites.forEach((satellite, index) => {
          const [px, py] = points[index];
          const spread = 1 + transition * (this.compact ? 0.38 : 0.42);
          const direction = index % 2 ? 1 : -1;
          const rotate = direction * transition * 22 + Math.sin(timeline * 2 + index) * 4;
          const scale = 1 + transition * 0.07;
          const limits = this.satelliteSizes[index];
          const radians = Math.abs(rotate) * Math.PI / 180;
          const rotatedWidth = (limits.width * Math.cos(radians) + limits.height * Math.sin(radians)) * scale;
          const rotatedHeight = (limits.height * Math.cos(radians) + limits.width * Math.sin(radians)) * scale;
          const maxX = Math.max(0, this.sceneWidth / 2 - rotatedWidth / 2 - 10);
          const maxY = Math.max(0, height / 2 - rotatedHeight / 2 - 8);
          const rawX = px * orbitWidth * spread;
          const rawY = py * height * spread + Math.sin(timeline * Math.PI + index) * (this.compact ? 7 : 18);
          const x = Math.max(-maxX, Math.min(maxX, rawX));
          const y = Math.max(-maxY, Math.min(maxY, rawY));
          satellite.style.transform = `translate(-50%,-50%) translate3d(${x.toFixed(2)}px,${y.toFixed(2)}px,0) rotate(${rotate.toFixed(2)}deg) scale(${scale.toFixed(3)})`;
          satellite.style.opacity = (1 - transition * 0.12).toFixed(3);
        });
        this.rings.forEach((ring, index) => {
          ring.style.transform = `translate(-50%,-50%) rotate(${(index ? 21 : -18) + timeline * (index ? -19 : 25)}deg) scale(${1 + transition * 0.08})`;
        });
        this.shadow.style.transform = `translateX(-50%) scaleX(${1 - transition * 0.45})`;
        this.shadow.style.opacity = String(1 - transition * 0.45);
        this.progressBar.style.transform = `scaleX(${this.current})`;
        const active = Math.round(timeline);
        if (active !== this.active) {
          this.active = active;
          this.details.forEach((detail, index) => { detail.hidden = index !== active; });
          this.buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === active)));
          this.counter.textContent = String(active + 1).padStart(2, '0');
        }
      }
      goTo(index) {
        if (this.reduced.matches) return;
        this.measure();
        const positions = [0.025, 0.5, 0.975];
        const top = this.start + this.distance * positions[index];
        this.scroller.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hadaki-rituals"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('hd-rituals')){customElements.define('hd-rituals',class extends HTMLElement{
connectedCallback(){this.controller=new AbortController();this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.cards=[...this.querySelectorAll('[data-hd-portrait]')];this.thumbs=[...this.querySelectorAll('[data-hd-thumb]')];this.filmstrip=this.querySelector('.hd-rituals__filmstrip');this.active=0;if(!this.cards.length)return;this.classList.add('is-enhanced');this.querySelector('.hd-rituals__controls').hidden=false;const options={signal:this.controller.signal};this.cards.forEach((card,index)=>card.addEventListener('click',()=>this.select(index,true),options));this.thumbs.forEach((thumb,index)=>thumb.addEventListener('click',()=>this.select(index,true),options));this.querySelector('[data-hd-previous]').addEventListener('click',()=>this.select(this.active-1,true),options);this.querySelector('[data-hd-next]').addEventListener('click',()=>this.select(this.active+1,true),options);this.addEventListener('keydown',event=>{if(!event.target.closest('button')||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();const next=event.key==='Home'?0:event.key==='End'?this.cards.length-1:this.active+(event.key==='ArrowRight'?1:-1);this.select(next,true);this.thumbs[this.active].focus({preventScroll:true})},options);window.addEventListener('resize',()=>this.select(this.active,false),{passive:true,signal:this.controller.signal});this.select(0,false)}
select(index,announce){this.active=(index+this.cards.length)%this.cards.length;const spacing=Math.max(30,Math.min(64,(this.querySelector('.hd-rituals__gallery').clientWidth-100)/5));this.cards.forEach((card,i)=>{const selected=i===this.active;const offset=i-(this.cards.length-1)/2;card.setAttribute('aria-pressed',String(selected));card.style.setProperty('--hd-card-x',selected?'0px':`${offset*spacing}px`);card.style.setProperty('--hd-card-y',selected?'-5px':`${Math.abs(offset)*4+10}px`);card.style.setProperty('--hd-card-angle',selected?'0deg':`${offset*7}deg`);card.style.setProperty('--hd-card-scale',selected?'1':'.86');card.style.setProperty('--hd-card-layer',String(selected?20:i+1))});this.thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===this.active)));if(announce){const thumb=this.thumbs[this.active];this.filmstrip.scrollTo({left:thumb.offsetLeft-(this.filmstrip.clientWidth-thumb.offsetWidth)/2,behavior:this.motion.matches?'instant':'smooth'});this.querySelector('[data-hd-photo-status]').textContent=this.dataset.statusTemplate.replace('__HD_NUMBER__',String(this.active+1))}}
disconnectedCallback(){this.controller?.abort()}
})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
